import { all } from 'redux-saga/effects';

//Saga
import configSaga from './configSaga';
import authSaga from './authSaga';
import logoutSaga from './logoutSaga';
import notificationSaga from './notificationSaga';
import timelineSaga from './timelineSaga';
import myProfileSaga from './myProfileSaga';
import myPhotoSaga from './myPhotoSaga';
import myProofSaga from './myProofSaga';
import myPostSaga from './myPostSaga';
import myPostGoodUserSaga from './myPostGoodUserSaga';
import myQaQuestionSaga from './myQaQuestionSaga';
import myQaAnswerSaga from './myQaAnswerSaga';
import myPersonalitySaga from './myPersonalitySaga';
import myKeywordSaga from './myKeywordSaga';
import partnerSaga from './partnerSaga';
import partnerOperationSaga from './partnerOperationSaga';
import partnerPostSaga from './partnerPostSaga';
import partnerQaSaga from './partnerQaSaga';
import mailGroupSaga from './mailGroupSaga';
import mailTalkSaga from './mailTalkSaga';
import mailSupportSaga from './mailSupportSaga';
import mailDraftSaga from './mailDraftSaga';
import bestpartnerSaga from './bestpartnerSaga';
import searchSaga from './searchSaga';
import footprintSaga from './footprintSaga';
import favoriteSaga from './favoriteSaga';
import nondisplaySaga from './nondisplaySaga';
import refusalSaga from './refusalSaga';
import breachSaga from './breachSaga';
import communityPostSaga from './communityPostSaga';
import communityQaSaga from './communityQaSaga';
import communityKeywordSaga from './communityKeywordSaga';
import memoSaga from './memoSaga';
import paymentTicketSaga from './paymentTicketSaga';
import coupleSaga from './coupleSaga';
import articlesSaga from './articlesSaga';
import campaignSaga from './campaignSaga';
import settingSaga from './settingSaga';
import helpSaga from './helpSaga';
import chargeSaga from './chargeSaga';
import actionLogSaga from './actionLogSaga';
import newsSaga from './newsSaga';

export default function* rootSaga() {
  yield all([
    ...configSaga,
    ...authSaga,
    ...logoutSaga,
    ...notificationSaga,
    ...timelineSaga,
    ...myProfileSaga,
    ...myPhotoSaga,
    ...myProofSaga,
    ...myPostSaga,
    ...myPostGoodUserSaga,
    ...myQaQuestionSaga,
    ...myQaAnswerSaga,
    ...myPersonalitySaga,
    ...myKeywordSaga,
    ...partnerSaga,
    ...partnerPostSaga,
    ...partnerQaSaga,
    ...partnerOperationSaga,
    ...mailGroupSaga,
    ...mailTalkSaga,
    ...mailSupportSaga,
    ...mailDraftSaga,
    ...bestpartnerSaga,
    ...searchSaga,
    ...footprintSaga,
    ...favoriteSaga,
    ...nondisplaySaga,
    ...refusalSaga,
    ...breachSaga,
    ...communityPostSaga,
    ...communityQaSaga,
    ...communityKeywordSaga,
    ...memoSaga,
    ...paymentTicketSaga,
    ...articlesSaga,
    ...campaignSaga,
    ...settingSaga,
    ...coupleSaga,
    ...helpSaga,
    ...chargeSaga,
    ...actionLogSaga,
    ...newsSaga,
  ]);
}
